// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Form from 'antd/lib/form';
//
import TinyMCE from 'react-tinymce';
import { Editor } from '@tinymce/tinymce-react';

const FormItem = Form.Item;

// SEE: https://ant.design/components/form/#components-form-demo-customized-form-controls
class TermsEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      termsHTML: this.props.value || undefined,
    };
  }

  componentWillReceiveProps(nextProps) {
    // Should be a controlled component.
    if (nextProps && nextProps.value) {
      const termsHTML = nextProps.value;
      this.setState({ termsHTML });
    }
  }

  handleEditorChange = content => {
    if (this.props.onChange) {
      this.props.onChange(content);
    }
  };

  render() {
    // don't render until some content is ready: https://github.com/instructure-react/react-tinymce/issues/90#issuecomment-354679873
    if (this.state.termsHTML === undefined) {
      return null;
    }

    return (
      <Editor
        config={{
          plugins: 'link',
          height: '480',
          toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
        }}
        init={{
          plugins: 'link table',
          height: '480',
          toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
        }}
        apiKey="5lyuk3fswlnbx4rzhwtigisnuu0rulj8uu1feigcaokshjbz"
        content={this.state.termsHTML}
        initialValue={this.state.termsHTML}
        onEditorChange={this.handleEditorChange}
      />
    );
  }
}

class TextEditorInput extends React.Component {
  render() {
    return (
      <div style={{ marginBottom: 20 }}>
        <TermsEditor {...this.props} />
      </div>
    );
  }
}

TextEditorInput.propTypes = {
  valueName: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
};

// Specifies the default values for props:
TextEditorInput.defaultProps = {
  label: '',
  placeholder: 'description here...',
  valueName: 'termsHTML',
};

export default TextEditorInput;



// WEBPACK FOOTER //
// ./src/components/inputs/TextEditorInput/index.js